
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import Sector from 'features/sector';
import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import useProtectedRoute from 'hooks/useProtectedRoute';
import { useRouter } from 'next/router';

function SectorPage() {
  const router = useRouter();
  const { isLoaded } = useProtectedRoute();

  const { slugs }: { slugs?: Array<string> } = router.query;

  return (
    <MainLayout maxWidth={990}>
      <PageLoader loaded={isLoaded} />
      <Sector slugs={slugs} />
    </MainLayout>
  );
}

export default SectorPage;
